import React, { useEffect } from "react"
import {
  Field,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { CheckboxField, RichTextField } from "components/RenderInput"
import { connect } from "react-redux"
import {
  getReferFriendFeature,
  resetReferFriendFeatureForm,
  updateReferFriendFeature,
} from "store/actions"
import validate from "./referFriendValidation"
import PropTypes from "prop-types"
import { LoadingIndicator } from "components/LoadingIndicator"

let ReferFirend = props => {
  useEffect(() => {
    props.getReferFriendFeature({ menu_item_id: props.feature.id })
    return () => {
      props.resetReferFriendFeatureForm()
    }
  }, [])

  useEffect(() => {
    if (props.referFriend && Object.keys(props.referFriend).length > 0) {
      props.initializeForm({
        refer_friend_form: {
          enableForVisitors: props.referFriend.enabled_for_visitors === 1,
          emailContent: props.referFriend.email_content,
          confirmationEmail: props.referFriend.send_copy_to_referrer === 1,
          referralEmailContent: props.referFriend?.referrer_email_content,
        },
      })
    }
  }, [props.referFriend])

  const submitHandler = data => {
    const params = {
      email_content: data.refer_friend_form.emailContent,
      enabled_for_visitors: data.refer_friend_form?.enableForVisitors ? 1 : 0,
      event_id: props?.selectedEvent?.id,
      menu_item_id: props.feature.id,
      referrer_email_content: data.refer_friend_form?.referralEmailContent,
      send_copy_to_referrer: data.refer_friend_form?.confirmationEmail ? 1 : 0,
      vendor_id: props.vendorId,
    }
    props.updateReferFriendFeature(params)
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col xl={12}>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            <Row className="my-3">
              <Col xl={12}>
                <Field
                  name="enableForVisitors"
                  component={CheckboxField}
                  label="Enable for Visitors"
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xl={12} className="my-1">
                <p>
                  Compose an email to the person being referred to the program.
                </p>
              </Col>
              <Col xl={12}>
                <Field name="emailContent" component={RichTextField} />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xl={12} className="my-2">
                <Field
                  name="confirmationEmail"
                  component={CheckboxField}
                  label="Compose a confirmation email to the person making the referral. (OPTIONAL)"
                />
              </Col>
              {props.confirmationEmail && (
                <Col xl={12}>
                  <Field
                    name="referralEmailContent"
                    component={RichTextField}
                  />
                </Col>
              )}
            </Row>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.handleSubmit(submitHandler)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

ReferFirend = reduxForm({
  form: FORM_NAMES.REFER_FRIEND,
  validate,
  initialValues: {
    refer_friend_form: {
      confirmationEmail: true,
    },
  },
})(ReferFirend)

const selector = formValueSelector(FORM_NAMES.REFER_FRIEND)

const mapStateToProps = state => ({
  confirmationEmail: selector(state, "refer_friend_form.confirmationEmail"),
  referFriend: state.ReferFriend.referFriend,
  loading: state.ReferFriend.loading,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  getReferFriendFeature: values => dispatch(getReferFriendFeature(values)),
  updateReferFriendFeature: values =>
    dispatch(updateReferFriendFeature(values)),
  resetReferFriendFeatureForm: () => dispatch(resetReferFriendFeatureForm()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.REFER_FRIEND, values)),
})

ReferFirend.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferFirend)
